import style from "./mainPartnership.module.scss";
import {PartnerCompanyVO} from "../../../types/partnerCompany";
import React, {RefObject} from "react";
import {useNavigate} from "react-router-dom";
import {useLanguage, useUserAgent} from "../../../hooks/hooks";

interface Args{
    title: string;
    detail: string;
    partnerCompany: PartnerCompanyVO[] | null;
    mainRef: RefObject<HTMLDivElement>;
    compareRef: RefObject<HTMLDivElement>;
    isOverflowing: boolean;
    animationDuration?: number;

}
export function PartnerField(
    {title, detail, partnerCompany, mainRef, compareRef, isOverflowing, animationDuration}:Args
) {
    const navigate = useNavigate();
    const{isKorean} = useLanguage();
    const { isMobile } = useUserAgent();
    const onClickDetail = () => {
        navigate('/partnerlist')
    }

    return(
        <div className={style.partnerArea}>
            <div className={style.titleWrapper}>
                <div className={style.title}>
                        <span className={style.text}>
                            {title}
                        </span>
                </div>
                {!isMobile && isKorean &&(
                    <div className={style.detail} onClick={onClickDetail}>
                        {detail}
                        <div className={style.rightStroke}/>
                    </div>
                )}
            </div>
            {partnerCompany && (
                <div className={style.carouselContainer} ref={mainRef}>
                    <div
                        className={`${style.listWrapper} ${isOverflowing ? style.animate : ''}`}
                        ref={compareRef}
                        style={{ '--animation-duration': `${animationDuration}s` } as React.CSSProperties}
                    >
                        {/* 오버플로우 여부에 따라 조건부 렌더링 */}
                        {isOverflowing
                            ? [...partnerCompany, ...partnerCompany].map((data, idx) => (
                                <img src={data.logo} alt={data.name} className={style.data} key={idx}/>
                            ))
                            : partnerCompany.map((data, idx) => (
                                <img src={data.logo} alt={data.name} className={style.data} key={idx}/>
                            ))
                        }
                    </div>
                </div>
            )}
        </div>

    )
}